window.Popper = require('popper.js').default;

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

window.inputmask = require('inputmask');

// window.axios = require('axios');
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// let token = document.head.querySelector('meta[name="csrf-token"]');

// if (token) {
//     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// }

// window.SwaggerUI = require('swagger-ui');
// window.SwaggerUIBundle = require('swagger-ui-dist').SwaggerUIBundle;


// WEBPACK FOOTER //
// ./resources/js/bootstrap.js